import {
	O365_REGISTER_REQUEST,
	O365_REGISTER_SUCCESS,
	O365_REGISTER_FAILURE,

	O365_LOAD_EVENTS_REQUEST,
	O365_LOAD_EVENTS_SUCCESS,
	O365_LOAD_EVENTS_FAILURE,

	O365_LOAD_EVENT_REQUEST,
	O365_LOAD_EVENT_SUCCESS,
	O365_LOAD_EVENT_FAILURE,

	O365_LOAD_USER_INFO_REQUEST,
	O365_LOAD_USER_INFO_SUCCESS,
	O365_LOAD_USER_INFO_FAILURE,

	O365_CREATE_EVENT_REQUEST,
	O365_CREATE_EVENT_SUCCESS,
	O365_CREATE_EVENT_FAILURE,

	O365_DELETE_EVENT_REQUEST,
	O365_DELETE_EVENT_SUCCESS,
	O365_DELETE_EVENT_FAILURE,

	O365_ACCEPT_EVENT_REQUEST,
	O365_ACCEPT_EVENT_SUCCESS,
	O365_ACCEPT_EVENT_FAILURE,

	O365_TENTATIVE_EVENT_REQUEST,
	O365_TENTATIVE_EVENT_SUCCESS,
	O365_TENTATIVE_EVENT_FAILURE,

	O365_DECLINE_EVENT_REQUEST,
	O365_DECLINE_EVENT_SUCCESS,
	O365_DECLINE_EVENT_FAILURE,

	CORE_LOAD_ORDERS_REQUEST,
	CORE_LOAD_ORDERS_SUCCESS,
	CORE_LOAD_ORDERS_FAILURE,

	CORE_LOAD_USER_INFO_REQUEST,
	CORE_LOAD_USER_INFO_SUCCESS,
	CORE_LOAD_USER_INFO_FAILURE,

	CORE_LOAD_TERM_REQUEST,
	CORE_LOAD_TERM_SUCCESS,
	CORE_LOAD_TERM_FAILURE,

	CORE_LOAD_CONTACT_REQUEST,
	CORE_LOAD_CONTACT_SUCCESS,
	CORE_LOAD_CONTACT_FAILURE,

	CORE_LOAD_FAQ_REQUEST,
	CORE_LOAD_FAQ_SUCCESS,
	CORE_LOAD_FAQ_FAILURE,

	CORE_LOAD_INTEGRATION_REQUEST,
	CORE_LOAD_INTEGRATION_SUCCESS,
	CORE_LOAD_INTEGRATION_FAILURE,

	CORE_USER_INTEGRATION_REQUEST,
	CORE_USER_INTEGRATION_SUCCESS,
	CORE_USER_INTEGRATION_FAILURE,

	CORE_LOAD_O365URL_REQUEST,
	CORE_LOAD_O365URL_SUCCESS,
	CORE_LOAD_O365URL_FAILURE,

	CORE_CHANGE_PASSWORD_REQUEST,
	CORE_CHANGE_PASSWORD_SUCCESS,
	CORE_CHANGE_PASSWORD_FAILURE,

	CORE_GET_ROOM_INFO_REQUEST,
	CORE_GET_ROOM_INFO_SUCCESS,
	CORE_GET_ROOM_INFO_FAILURE,

	CORE_GET_ROOM_STATUS_REQUEST,
	CORE_GET_ROOM_STATUS_SUCCESS,
	CORE_GET_ROOM_STATUS_FAILURE,

	O365_LOAD_EVENTLIST_REQUEST,
	O365_LOAD_EVENTLIST_SUCCESS,
	O365_LOAD_EVENTLIST_FAILURE,

	O365_LOAD_EVENTDETAIL_REQUEST,
	O365_LOAD_EVENTDETAIL_SUCCESS,
	O365_LOAD_EVENTDETAIL_FAILURE,

	CORE_CHECKIN_REQUEST,
	CORE_CHECKIN_SUCCESS,
	CORE_CHECKIN_FAILURE,

	O365_CHECKOUT_REQUEST,
	O365_CHECKOUT_SUCCESS,
	O365_CHECKOUT_FAILURE,

	O365_SUGGEST_ROOM_REQUEST,
	O365_SUGGEST_ROOM_SUCCESS,
	O365_SUGGEST_ROOM_FAILURE,

	O365_SUGGESTTION_REQUEST,
	O365_SUGGESTTION_SUCCESS,
	O365_SUGGESTTION_FAILURE,

	O365_UPDATE_EVENT_REQUEST,
	O365_UPDATE_EVENT_SUCCESS,
	O365_UPDATE_EVENT_FAILURE,

	BSRS_LOGIN_REQUEST,
	BSRS_LOGIN_SUCCESS,
	BSRS_LOGIN_FAILURE,

	// CORE_LOAD_FOODACTIVE_REQUEST,
	// CORE_LOAD_FOODACTIVE_SUCCESS,
	// CORE_LOAD_FOODACTIVE_FAILURE,

	// CORE_LOAD_FOODPAST_REQUEST,
	// CORE_LOAD_FOODPAST_SUCCESS,
	// CORE_LOAD_FOODPAST_FAILURE,

	SERVICE_DELETE_EVENT_REQUEST,
	SERVICE_DELETE_EVENT_SUCCESS,
	SERVICE_DELETE_EVENT_FAILURE,

	CORE_LOAD_FOODNEXT_REQUEST,
	CORE_LOAD_FOODNEXT_SUCCESS,
	CORE_LOAD_FOODNEXT_FAILURE,

	CORE_SENDFOOD_REQUEST,
	CORE_SENDFOOD_SUCCESS,
	CORE_SENDFOOD_FAILURE,

	CORE_DONEFOOD_REQUEST,
	CORE_DONEFOOD_SUCCESS,
	CORE_DONEFOOD_FAILURE,

	CORE_LOAD_EVENTINFOSERVICE_REQUEST,
	CORE_LOAD_EVENTINFOSERVICE_SUCCESS,
	CORE_LOAD_EVENTINFOSERVICE_FAILURE,

	CORE_UPDATE_ORDER_REQUEST,
	CORE_UPDATE_ORDER_SUCCESS,
	CORE_UPDATE_ORDER_FAILURE,

	CORE_CREATE_ORDER_REQUEST,
	CORE_CREATE_ORDER_SUCCESS,
	CORE_CREATE_ORDER_FAILURE,

	CORE_LOAD_FBS_REQUEST,
	CORE_LOAD_FBS_SUCCESS,
	CORE_LOAD_FBS_FAILURE,

	CORE_LOAD_EVENTS_REQUEST,
	CORE_LOAD_EVENTS_SUCCESS,
	CORE_LOAD_EVENTS_FAILURE,

	SERVICE_SEARCH_USERS_REQUEST,
	SERVICE_SEARCH_USERS_SUCCESS,
	SERVICE_SEARCH_USERS_FAILURE,

	CORE_LOAD_ORDERS_EVENT_REQUEST,
	CORE_LOAD_ORDERS_EVENT_SUCCESS,
	CORE_LOAD_ORDERS_EVENT_FAILURE,

	O365_LOAD_EVENTLIST_BETWEEN_REQUEST,
	O365_LOAD_EVENTLIST_BETWEEN_SUCCESS,
	O365_LOAD_EVENTLIST_BETWEEN_FAILURE,

	O365_LOAD_EVENTLISTFULL_BETWEEN_REQUEST,
	O365_LOAD_EVENTLISTFULL_BETWEEN_SUCCESS,
	O365_LOAD_EVENTLISTFULL_BETWEEN_FAILURE,

	CORE_UPDATE_TIMEZONE_REQUEST,
	CORE_UPDATE_TIMEZONE_SUCCESS,
	CORE_UPDATE_TIMEZONE_FAILURE,

	CORE_LOAD_SUGGEST_INFORMATION_REQUEST,
	CORE_LOAD_SUGGEST_INFORMATION_SUCCESS,
	CORE_LOAD_SUGGEST_INFORMATION_FAILURE,

	CORE_UPDATE_USER_REQUEST,
	CORE_UPDATE_USER_SUCCESS,
	CORE_UPDATE_USER_FAILURE,

	CORE_GET_FAVORITESEAT_REQUEST,
	CORE_GET_FAVORITESEAT_SUCCESS,
	CORE_GET_FAVORITESEAT_FAILURE,

	CORE_LOAD_ALL_BUILDING_REQUEST,
	CORE_LOAD_ALL_BUILDING_SUCCESS,
	CORE_LOAD_ALL_BUILDING_FAILURE,

	CORE_LOAD_ALL_FLOOR_REQUEST,
	CORE_LOAD_ALL_FLOOR_SUCCESS,
	CORE_LOAD_ALL_FLOOR_FAILURE,

	CORE_LOAD_ALL_ZONE_REQUEST,
	CORE_LOAD_ALL_ZONE_SUCCESS,
	CORE_LOAD_ALL_ZONE_FAILURE,

	CORE_SUGGEST_SEAT_REQUEST,
	CORE_SUGGEST_SEAT_SUCCESS,
	CORE_SUGGEST_SEAT_FAILURE,

	CORE_CREATE_EVENT_SEAT_REQUEST,
	CORE_CREATE_EVENT_SEAT_SUCCESS,
	CORE_CREATE_EVENT_SEAT_FAILURE,

	CORE_GET_EVENT_SEATGROUP_REQUEST,
	CORE_GET_EVENT_SEATGROUP_SUCCESS,
	CORE_GET_EVENT_SEATGROUP_FAILURE,

	CORE_GET_MYEVENT_SEATBYDATE_REQUEST,
	CORE_GET_MYEVENT_SEATBYDATE_SUCCESS,
	CORE_GET_MYEVENT_SEATBYDATE_FAILURE,

	CORE_SEARCH_ROOM_REQUEST,
	CORE_SEARCH_ROOM_SUCCESS,
	CORE_SEARCH_ROOM_FAILURE,

	CORE_ADD_FAVORITEROOM_REQUEST,
	CORE_ADD_FAVORITEROOM_SUCCESS,
	CORE_ADD_FAVORITEROOM_FAILURE,

	CORE_REMOVE_FAVORITEROOM_REQUEST,
	CORE_REMOVE_FAVORITEROOM_SUCCESS,
	CORE_REMOVE_FAVORITEROOM_FAILURE,

	CORE_DELETE_EVENT_SEAT_REQUEST,
	CORE_DELETE_EVENT_SEAT_SUCCESS,
	CORE_DELETE_EVENT_SEAT_FAILURE,

	CORE_DELETE_ORDERAMENITY_REQUEST,
	CORE_DELETE_ORDERAMENITY_SUCCESS,
	CORE_DELETE_ORDERAMENITY_FAILURE,

	CORE_DELETE_ORDERFOODANDBEV_REQUEST,
	CORE_DELETE_ORDERFOODANDBEV_SUCCESS,
	CORE_DELETE_ORDERFOODANDBEV_FAILURE,

	CORE_LOAD_ORDERINFO_REQUEST,
	CORE_LOAD_ORDERINFO_SUCCESS,
	CORE_LOAD_ORDERINFO_FAILURE,

	CORE_CREATE_AMENITIES_REQUEST,
	CORE_CREATE_AMENITIES_SUCCESS,
	CORE_CREATE_AMENITIES_FAILURE,

	CORE_CREATE_FOODANDBEV_REQUEST,
	CORE_CREATE_FOODANDBEV_SUCCESS,
	CORE_CREATE_FOODANDBEV_FAILURE,

	CORE_FORGOT_PASSWORD_REQUEST,
	CORE_FORGOT_PASSWORD_SUCCESS,
	CORE_FORGOT_PASSWORD_FAILURE,

	CORE_CONFIRM_RESET_PASSWORD_REQUEST,
	CORE_CONFIRM_RESET_PASSWORD_SUCCESS,
	CORE_CONFIRM_RESET_PASSWORD_FAILURE,

	CORE_GET_ROOMDISABLE_REQUEST,
	CORE_GET_ROOMDISABLE_SUCCESS,
	CORE_GET_ROOMDISABLE_FAILURE,

	SET_ERROR,
} from '../../types'

const initialState = {
	hasError: false,
	isLoading: false,
	error: null,
}
export default (state = initialState, action) => {

	switch (action.type) {
		case O365_REGISTER_REQUEST:
		case O365_LOAD_EVENTS_REQUEST:
		case O365_LOAD_EVENT_REQUEST:
		case O365_LOAD_USER_INFO_REQUEST:
		case O365_CREATE_EVENT_REQUEST:
		case O365_DELETE_EVENT_REQUEST:
		case O365_ACCEPT_EVENT_REQUEST:
		case O365_TENTATIVE_EVENT_REQUEST:
		case O365_DECLINE_EVENT_REQUEST:
		case CORE_LOAD_ORDERS_REQUEST:
		case CORE_LOAD_USER_INFO_REQUEST:
		case CORE_LOAD_TERM_REQUEST:
		case CORE_LOAD_CONTACT_REQUEST:
		case CORE_LOAD_FAQ_REQUEST:
		case CORE_LOAD_INTEGRATION_REQUEST:
		case CORE_USER_INTEGRATION_REQUEST:
		case CORE_LOAD_O365URL_REQUEST:
		case CORE_CHANGE_PASSWORD_REQUEST:
		case CORE_GET_ROOM_INFO_REQUEST:
		case CORE_GET_ROOM_STATUS_REQUEST:
		case O365_LOAD_EVENTLIST_REQUEST:
		case O365_LOAD_EVENTDETAIL_REQUEST:
		case CORE_CHECKIN_REQUEST:
		case O365_CHECKOUT_REQUEST:
		case O365_SUGGEST_ROOM_REQUEST:
		case O365_UPDATE_EVENT_REQUEST:
		case BSRS_LOGIN_REQUEST:
		case CORE_LOAD_FOODNEXT_REQUEST:
		case CORE_SENDFOOD_REQUEST:
		case CORE_DONEFOOD_REQUEST:
		case CORE_LOAD_EVENTINFOSERVICE_REQUEST:
		case CORE_UPDATE_ORDER_REQUEST:
		case CORE_CREATE_ORDER_REQUEST:
		case CORE_LOAD_FBS_REQUEST:
		case CORE_LOAD_EVENTS_REQUEST:
		case SERVICE_SEARCH_USERS_REQUEST:
		case CORE_LOAD_ORDERS_EVENT_REQUEST:
		case O365_LOAD_EVENTLIST_BETWEEN_REQUEST:
		case SERVICE_DELETE_EVENT_REQUEST:
		case O365_LOAD_EVENTLISTFULL_BETWEEN_REQUEST:
		case CORE_UPDATE_TIMEZONE_REQUEST:
		case CORE_LOAD_SUGGEST_INFORMATION_REQUEST:
		case O365_SUGGESTTION_REQUEST:
		case CORE_UPDATE_USER_REQUEST:
		case CORE_GET_FAVORITESEAT_REQUEST:
		case CORE_LOAD_ALL_BUILDING_REQUEST:
		case CORE_LOAD_ALL_FLOOR_REQUEST:
		case CORE_LOAD_ALL_ZONE_REQUEST:
		case CORE_SUGGEST_SEAT_REQUEST:
		case CORE_CREATE_EVENT_SEAT_REQUEST:
		case CORE_GET_EVENT_SEATGROUP_REQUEST:
		case CORE_GET_MYEVENT_SEATBYDATE_REQUEST:
		case CORE_SEARCH_ROOM_REQUEST:
		case CORE_ADD_FAVORITEROOM_REQUEST:
		case CORE_REMOVE_FAVORITEROOM_REQUEST:
		case CORE_DELETE_EVENT_SEAT_REQUEST:
		case CORE_DELETE_ORDERAMENITY_REQUEST:
		case CORE_DELETE_ORDERFOODANDBEV_REQUEST:
		case CORE_LOAD_ORDERINFO_REQUEST:
		case CORE_CREATE_AMENITIES_REQUEST:
		case CORE_CREATE_FOODANDBEV_REQUEST:
		case CORE_FORGOT_PASSWORD_REQUEST:
		case CORE_CONFIRM_RESET_PASSWORD_REQUEST:
		case CORE_GET_ROOMDISABLE_REQUEST:
			return {
				...state,
				isLoading: true,
				hasError: false,
				error: null,
			}
		case O365_REGISTER_SUCCESS:
		case O365_LOAD_EVENTS_SUCCESS:
		case O365_LOAD_EVENT_SUCCESS:
		case O365_LOAD_USER_INFO_SUCCESS:
		case O365_CREATE_EVENT_SUCCESS:
		case O365_DELETE_EVENT_SUCCESS:
		case O365_ACCEPT_EVENT_SUCCESS:
		case O365_TENTATIVE_EVENT_SUCCESS:
		case O365_DECLINE_EVENT_SUCCESS:
		case CORE_LOAD_ORDERS_SUCCESS:
		case CORE_LOAD_USER_INFO_SUCCESS:
		case CORE_LOAD_TERM_SUCCESS:
		case CORE_LOAD_CONTACT_SUCCESS:
		case CORE_LOAD_FAQ_SUCCESS:
		case CORE_LOAD_INTEGRATION_SUCCESS:
		case CORE_USER_INTEGRATION_SUCCESS:
		case CORE_LOAD_O365URL_SUCCESS:
		case CORE_CHANGE_PASSWORD_SUCCESS:
		case CORE_GET_ROOM_INFO_SUCCESS:
		case CORE_GET_ROOM_STATUS_SUCCESS:
		case O365_LOAD_EVENTLIST_SUCCESS:
		case O365_LOAD_EVENTDETAIL_SUCCESS:
		case CORE_CHECKIN_SUCCESS:
		case O365_CHECKOUT_SUCCESS:
		case O365_SUGGEST_ROOM_SUCCESS:
		case O365_UPDATE_EVENT_SUCCESS:
		case BSRS_LOGIN_SUCCESS:
		case CORE_LOAD_FOODNEXT_SUCCESS:
		case CORE_SENDFOOD_SUCCESS:
		case CORE_DONEFOOD_SUCCESS:
		case CORE_LOAD_EVENTINFOSERVICE_SUCCESS:
		case CORE_UPDATE_ORDER_SUCCESS:
		case CORE_CREATE_ORDER_SUCCESS:
		case CORE_LOAD_FBS_SUCCESS:
		case CORE_LOAD_EVENTS_SUCCESS:
		case SERVICE_SEARCH_USERS_SUCCESS:
		case CORE_LOAD_ORDERS_EVENT_SUCCESS:
		case O365_LOAD_EVENTLIST_BETWEEN_SUCCESS:
		case SERVICE_DELETE_EVENT_SUCCESS:
		case O365_LOAD_EVENTLISTFULL_BETWEEN_SUCCESS:
		case CORE_UPDATE_TIMEZONE_SUCCESS:
		case CORE_LOAD_SUGGEST_INFORMATION_SUCCESS:
		case O365_SUGGESTTION_SUCCESS:
		case CORE_UPDATE_USER_SUCCESS:
		case CORE_GET_FAVORITESEAT_SUCCESS:
		case CORE_LOAD_ALL_BUILDING_SUCCESS:
		case CORE_LOAD_ALL_FLOOR_SUCCESS:
		case CORE_LOAD_ALL_ZONE_SUCCESS:
		case CORE_SUGGEST_SEAT_SUCCESS:
		case CORE_CREATE_EVENT_SEAT_SUCCESS:
		case CORE_GET_EVENT_SEATGROUP_SUCCESS:
		case CORE_GET_MYEVENT_SEATBYDATE_SUCCESS:
		case CORE_SEARCH_ROOM_SUCCESS:
		case CORE_ADD_FAVORITEROOM_SUCCESS:
		case CORE_REMOVE_FAVORITEROOM_SUCCESS:
		case CORE_DELETE_EVENT_SEAT_SUCCESS:
		case CORE_DELETE_ORDERAMENITY_SUCCESS:
		case CORE_DELETE_ORDERFOODANDBEV_SUCCESS:
		case CORE_LOAD_ORDERINFO_SUCCESS:
		case CORE_CREATE_AMENITIES_SUCCESS:
		case CORE_CREATE_FOODANDBEV_SUCCESS:
		case CORE_FORGOT_PASSWORD_SUCCESS:
		case CORE_CONFIRM_RESET_PASSWORD_SUCCESS:
		case CORE_GET_ROOMDISABLE_SUCCESS:
			return {
				...state,
				isLoading: false,
				hasError: false,
				error: null,
			}

		case O365_LOAD_USER_INFO_FAILURE:
		case O365_LOAD_EVENT_FAILURE:
		case O365_LOAD_EVENTS_FAILURE:
		case O365_CREATE_EVENT_FAILURE:
		case O365_DELETE_EVENT_FAILURE:
		case O365_ACCEPT_EVENT_FAILURE:
		case O365_TENTATIVE_EVENT_FAILURE:
		case O365_DECLINE_EVENT_FAILURE:
		case CORE_LOAD_ORDERS_FAILURE:
		case CORE_LOAD_USER_INFO_FAILURE:
		case CORE_LOAD_TERM_FAILURE:
		case CORE_LOAD_CONTACT_FAILURE:
		case CORE_LOAD_FAQ_FAILURE:
		case CORE_LOAD_INTEGRATION_FAILURE:
		case CORE_USER_INTEGRATION_FAILURE:
		case O365_REGISTER_FAILURE:
		case CORE_LOAD_O365URL_FAILURE:
		case CORE_CHANGE_PASSWORD_FAILURE:
		case CORE_GET_ROOM_INFO_FAILURE:
		case CORE_GET_ROOM_STATUS_FAILURE:
		case O365_LOAD_EVENTLIST_FAILURE:
		case O365_LOAD_EVENTDETAIL_FAILURE:
		case CORE_CHECKIN_FAILURE:
		case O365_CHECKOUT_FAILURE:
		case O365_SUGGEST_ROOM_FAILURE:
		case O365_UPDATE_EVENT_FAILURE:
		case BSRS_LOGIN_FAILURE:
		case CORE_LOAD_FOODNEXT_FAILURE:
		case CORE_SENDFOOD_FAILURE:
		case CORE_DONEFOOD_FAILURE:
		case CORE_LOAD_EVENTINFOSERVICE_FAILURE:
		case CORE_UPDATE_ORDER_FAILURE:
		case CORE_CREATE_ORDER_FAILURE:
		case CORE_LOAD_FBS_FAILURE:
		case CORE_LOAD_EVENTS_FAILURE:
		case SERVICE_SEARCH_USERS_FAILURE:
		case CORE_LOAD_ORDERS_EVENT_FAILURE:
		case O365_LOAD_EVENTLIST_BETWEEN_FAILURE:
		case SERVICE_DELETE_EVENT_FAILURE:
		case O365_LOAD_EVENTLISTFULL_BETWEEN_FAILURE:
		case CORE_UPDATE_TIMEZONE_FAILURE:
		case CORE_LOAD_SUGGEST_INFORMATION_FAILURE:
		case O365_SUGGESTTION_FAILURE:
		case CORE_UPDATE_USER_FAILURE:
		case CORE_GET_FAVORITESEAT_FAILURE:
		case CORE_LOAD_ALL_BUILDING_FAILURE:
		case CORE_LOAD_ALL_FLOOR_FAILURE:
		case CORE_LOAD_ALL_ZONE_FAILURE:
		case CORE_SUGGEST_SEAT_FAILURE:
		case CORE_CREATE_EVENT_SEAT_FAILURE:
		case CORE_GET_EVENT_SEATGROUP_FAILURE:
		case CORE_GET_MYEVENT_SEATBYDATE_FAILURE:
		case CORE_SEARCH_ROOM_FAILURE:
		case CORE_ADD_FAVORITEROOM_FAILURE:
		case CORE_REMOVE_FAVORITEROOM_FAILURE:
		case CORE_DELETE_EVENT_SEAT_FAILURE:
		case CORE_DELETE_ORDERAMENITY_FAILURE:
		case CORE_DELETE_ORDERFOODANDBEV_FAILURE:
		case CORE_LOAD_ORDERINFO_FAILURE:
		case CORE_CREATE_AMENITIES_FAILURE:
		case CORE_CREATE_FOODANDBEV_FAILURE:
		case CORE_FORGOT_PASSWORD_FAILURE:
		case CORE_CONFIRM_RESET_PASSWORD_FAILURE:
		case CORE_GET_ROOMDISABLE_FAILURE:
			let returnData = {
				...state,
				isLoading: false,
				hasError: true,
				error: action.payload.data,
			}
			return returnData
		case SET_ERROR:
			return {
				...state,
				hasError: action.hasError,
				error: action.error
			}
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/features/ui/reducer.js